import React from 'react';
import { MFASetup as Setup } from '@/features/auth';
import PageMeta from '@/shared/components/PageMeta';

export const MFASetup: React.FC = () => {
    return (
        <>
            <PageMeta
                title="Two-Factor Authentication"
                description="Complete your login with two-factor authentication"
            />
            <Setup />
        </>
    );
};
